import { render, staticRenderFns } from "./AdminMorebbsWarning.vue?vue&type=template&id=25df04d8&"
import script from "./AdminMorebbsWarning.vue?vue&type=script&lang=js&"
export * from "./AdminMorebbsWarning.vue?vue&type=script&lang=js&"
import style0 from "./AdminMorebbsWarning.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports